const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export async function fetchBlogPosts() {
  const res = await fetch(`${API}/blog`);
  if (!res.ok) throw new Error(`Failed to load blog posts (${res.status})`);
  return res.json();
}

export async function fetchBlogPost(slug) {
  const res = await fetch(`${API}/blog/${slug}`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`Failed to load blog post (${res.status})`);
  return res.json();
}

// Posts the build put into the page (see scripts/prerender.js), so the blog
// shows straight away instead of waiting for the API. Shape:
// { list: [...summaries], post: {...one full post} | null }
export function initialBlogData() {
  const g = typeof window !== 'undefined' ? window : globalThis;
  return g.__PIB_BLOG__ || null;
}

// Dates from the API have no time zone; they are stored in UTC.
function parseUtc(iso) {
  if (!iso) return null;
  const s = String(iso);
  return new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(s) ? s : `${s}Z`);
}

export function formatPostDate(iso) {
  const d = parseUtc(iso);
  return d
    ? d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/London' })
    : '';
}

// When the post was first published, and when its text last changed. A post
// counts as edited only if it was saved again after it was first stored, so
// moving posts between systems does not look like an edit.
export function postDates(post) {
  const published = parseUtc(post.published_at);
  const created = parseUtc(post.created_at);
  const updated = parseUtc(post.updated_at);
  let modified = published;
  if (updated && created && updated - created > 60 * 1000 && (!published || updated > published)) {
    modified = updated;
  }
  return {
    published: published ? published.toISOString() : undefined,
    modified: modified ? modified.toISOString() : undefined,
  };
}
